import React from 'react';
import { MinusIcon, TickIcon } from '@fourthwall/icons';
import { Icon } from '../../../common/Icon';
import * as S from './CheckboxIcon.styled';
import { TICK_ICON_SIZE } from './consts';
export const CheckboxIcon = ({ size = 'medium', indeterminate }) => (React.createElement(S.Container, { "$size": size, "aria-hidden": "true" }, indeterminate ? (React.createElement(Icon, { component: MinusIcon, height: TICK_ICON_SIZE[size] })) : (React.createElement(Icon, { component: TickIcon, height: TICK_ICON_SIZE[size] }))));
//# sourceMappingURL=CheckboxIcon.js.map